var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1-User-Management_05",
    transform: "translate(-618.000000, -534.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627,534.666667 C622.4,534.666667 618.666667,538.4 618.666667,543 C618.666667,547.6 622.4,551.333333 627,551.333333 C631.6,551.333333 635.333333,547.6 635.333333,543 C635.333333,538.4 631.6,534.666667 627,534.666667 Z M627.833333,543.833333 L626.166667,543.833333 L626.166667,538.833333 L627.833333,538.833333 L627.833333,543.833333 Z M627.833333,547.166667 L626.166667,547.166667 L626.166667,545.5 L627.833333,545.5 L627.833333,547.166667 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.99cd21ce2135307f0d47caf9b70a987c.svg";
export { ForwardRef as ReactComponent };